module.exports = __webpack_public_path__ + "img/mid-banner.40d828c.png";